import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,

        options: {
            customProperties: true,
        },

        themes: {
             light: {
                primary: '#575761',
                secondary: '#648381',
                accent: '#cc4c7c',

                info: '#FFBF46',
                success: '#FFBF46',

                warning: '#c3073f',   
                error: '#c3073f',    
                
                primaryText: '#ffffff',
                secondaryText: '#ffffff',
                accentText: '#ffffff',
                infoText: '#000000',
                warningText: '#ffffff',

                background: '#f5f2f2',
                border: '#f0f0f0'
            }, 
            dark: {
                primary: '#575761',
                secondary: '#648381',
                accent: '#cc4c7c',

                info: '#FFBF46',
                success: '#FFBF46',

                warning: '#c3073f',   
                error: '#c3073f',  

                primaryText: '#ffffff',
                secondaryText: '#ffffff',
                accentText: '#ffffff',
                infoText: '#000000',
                warningText: '#ffffff',

                background: '#f5f2f2',
                border: '#f0f0f0'
            }            
            
/*             light: {
                primary: '#000000',
                secondary: '383838',
                accent: 'ff6c26',

                info: '#FFBF46',
                success: '#1e9b04',

                warning: '#c3073f',   
                error: '#c3073f',    
                
                primaryText: '#ffffff',
                secondaryText: '#ffffff',
                accentText: '#ffffff',
                infoText: '#000000',
                warningText: '#ffffff',

                background: '#f5f2f2',
                border: '#f0f0f0'
            },            
            dark: {
                primary: '#000000',
                secondary: '383838',
                accent: 'ff6c26',

                info: '#FFBF46',
                success: '#1e9b04',

                warning: '#c3073f',   
                error: '#c3073f',    
                
                primaryText: '#ffffff',
                secondaryText: '#ffffff',
                accentText: '#ffffff',
                infoText: '#000000',
                warningText: '#ffffff',

                background: '#f5f2f2',
                border: '#f0f0f0'
            } */
        },
    },
});
